import VimeoPlayer from 'react-player/vimeo';
import { useTranslation } from '@klv/hooks/useTranslation';

import Modal from '@klv/organisms/modal';
import { useModal } from '@klv/context/modal';
import { hash } from '@klv/shared/utils/functions';
import { VideoColorPlayButton } from '@klv/atoms/video-color-play-button';
import * as s from './styles/videoModalTrigger.module.scss';

import type { IVideoModalTrigger } from './types';
import { gtmBasicEvent } from '@klv/shared/utils/google-tag-manager';

const VideoModalTrigger = ({
  children,
  modalHeadline = '',
  onClick,
  tabIndex,
  videoUrl,
  videoDuration,
  videoPlayButtonColor,
  videoOverlayTitle,
  className = '',
}: IVideoModalTrigger) => {
  const { t } = useTranslation();

  const modalId = `${hash(JSON.stringify([modalHeadline, videoUrl]))}`;
  const modalStore = useModal();
  const { modalState } = modalStore;
  const showModal = (modalState.visibleModalId === modalId);

  const videoTitle  = videoUrl === 'https://vimeo.com/1056838881' ? 'B2C CRM Platform Demo - EN on Vimeo | 1056838881' : videoUrl;

  const defaultOnClick = () => {
    gtmBasicEvent({
      eventName: 'vimeo',
      label: videoTitle,
      category: 'Video',
      action: 'play',
    });
    modalStore.open(modalId);
  };

  return (
    <div className={`modalTrigger ${s.videoModalTrigger} ${className}`}>
      <button className={s.clickableArea} onClick={onClick || defaultOnClick} tabIndex={tabIndex} type="button">
        <VideoColorPlayButton videoPlayButtonColor={videoPlayButtonColor} />
        {videoDuration && <div className={s.videoDuration} >{videoDuration}</div>}
        {videoOverlayTitle && 
        <div className={s.videoOverlayTitleWrapper}>
          <div className={s.videoOverlayTitle}>{videoOverlayTitle}</div> 
        </div>
        }      
      </button>
      {children}
      {showModal && (
        <Modal
          close={modalStore.close}
          show={showModal}
          size="constrained"
          backgroundColor="lightSand"
          isMediaModal
          title={modalHeadline || ' '}
        >
          <VimeoPlayer
            className={`react-player ${s.video}`}
            url={videoUrl}
            controls
            playing
            loop={false}
            width="100%"
            height="auto"
            config={{ playerOptions:{ texttrack: t('langCodes_recaptchaLanguage') === 'en' ? '' : t('langCodes_recaptchaLanguage') } } }  
          />
        </Modal>
      )}
    </div>
  );
};

export default VideoModalTrigger;
